import { render, staticRenderFns } from "./BlockExtraActions.vue?vue&type=template&id=7a63bc24&"
import script from "./BlockExtraActions.vue?vue&type=script&lang=js&"
export * from "./BlockExtraActions.vue?vue&type=script&lang=js&"
import style0 from "./BlockExtraActions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports